import React from "react";

const DEKNINGSKART_URL = "https://coverage.ddc.teliasonera.net/coverageportal_no?profile=ALL";

interface Props {
    className?: string;
}

const DekningskartIframe: React.FC<Props> = ({ className }) => (
    <iframe
        src={DEKNINGSKART_URL}
        title="Dekningskart"
        allow="geolocation"
        loading="lazy"
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
        className={className}
        frameBorder="0"
    />
);

export default DekningskartIframe;
